import { createContext, useContext, useState, useEffect } from 'react';
import { toast } from 'sonner';

const CompareContext = createContext(null);
const STORAGE_KEY = 'engineshipparts_compare_list';

export function CompareProvider({ children }) {
  const [compareList, setCompareList] = useState(() => {
    // Load from localStorage on initial render
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  // Persist to localStorage whenever compareList changes
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(compareList));
    } catch {
      // localStorage might be full or disabled
    }
  }, [compareList]);

  const addToCompare = (engine) => {
    if (compareList.length >= 4) {
      toast.error('You can compare up to 4 engines at a time');
      return false;
    }
    if (compareList.find(e => e.id === engine.id)) {
      toast.info('Engine already in compare list');
      return false;
    }
    setCompareList(prev => [...prev, engine]);
    toast.success(`${engine.title} added to compare`);
    return true;
  };

  const removeFromCompare = (engineId) => {
    setCompareList(prev => prev.filter(e => e.id !== engineId));
    toast.info('Engine removed from compare list');
  };

  const clearCompare = () => {
    setCompareList([]);
  };

  const isInCompare = (engineId) => {
    return compareList.some(e => e.id === engineId);
  };

  return (
    <CompareContext.Provider value={{ compareList, addToCompare, removeFromCompare, clearCompare, isInCompare }}>
      {children}
    </CompareContext.Provider>
  );
}

export function useCompare() {
  const context = useContext(CompareContext);
  if (!context) {
    throw new Error('useCompare must be used within a CompareProvider');
  }
  return context;
}
